import 'dayjs/locale/id'

import { Icon } from '@iconify/react'
// import { pdf } from '@react-pdf/renderer'
import dayjs from 'dayjs'
import { useEffect, useRef } from 'react'
import { FieldValues, SubmitHandler, useForm } from 'react-hook-form'

import { COUNTRY_CALLING_CODES } from '~/constants/country'
import { ERROR_MESSAGES } from '~/constants/messages'
import useRequestTicket from '~/hooks/useRequestTicket'
import type { OptionProps } from '~/types/component'
import type { ModalPhoneProps } from '~/types/ticket'
import { rxNumber } from '~/utils/regex'

import Button from '../common/Button'
import Input from '../common/Input'
import Modal from '../common/Modal'
// import Select from '../common/Select'
// import TicketPDF from './TicketPDF'

const countryCodes = COUNTRY_CALLING_CODES.map((code) => ({
  value: code,
  label: code,
}))

const ModalPhone = ({ isOpen, closeModal, locationId, necessaryId, kodeUnik, prefillPhone }: ModalPhoneProps) => {
  const { requestTicket, isLoading } = useRequestTicket({ locationId, necessaryId, kodeUnik })

  const ticketContainerRef = useRef(null)

  const {
    register,
    handleSubmit,
    setValue,
    // watch,
    // clearErrors,
    reset,
    formState: { errors },
  } = useForm({
    defaultValues: {
      code: countryCodes[0] as OptionProps | undefined,
      phone: '',
    },
  })

  // const selectedCode = watch('code')

  useEffect(() => {
    register('code', { required: ERROR_MESSAGES.REQUIRED_CODE })
  }, [register])

  // Kode Unik flow prefills the customer's verified phone (this component stays
  // mounted the whole time isOpen toggles, so defaultValues alone won't pick it up).
  useEffect(() => {
    if (isOpen && prefillPhone) {
      setValue('phone', prefillPhone)
    }
  }, [isOpen, prefillPhone, setValue])

  const handleCloseModalAndReset = () => {
    closeModal()
    reset()
  }

  const onSubmit: SubmitHandler<FieldValues> = async (data) => {
    if (data.code && data.phone) {
      try {
        await requestTicket(data.phone as string)
        handleCloseModalAndReset()
      } catch {
        // useRequestTicket's mutation onError already surfaces a toast.
      }
    }
  }
  return (
    <Modal isOpen={isOpen} closeModal={handleCloseModalAndReset}>
      <form onSubmit={handleSubmit(onSubmit)}>
        <div className="mb-2 text-2xl font-bold text-jba-blue">Selesaikan 1 langkah lagi</div>
        <div className="mb-4 text-xs text-gray-500">
          Masukkan nomor whatsapp Anda untuk mendapatkan nomor antrean. Nomor antrean hanya berlaku untuk satu hari
          saja.
        </div>
        <div className="mb-8 inline-flex items-center gap-1 text-xs text-jba-blue">
          <Icon icon="fluent:calendar-clock-20-filled" className="text-base" />
          {dayjs(new Date()).locale('id').format('dddd, D MMMM YYYY')}
        </div>
        <div className="mb-6 flex gap-4 md:mb-10">
          {/* <div className="w-28">
            <Select
              placeholder="Code"
              options={countryCodes}
              rounded="xl"
              selected={selectedCode}
              setSelected={(value) => {
                setValue('code', value)
                clearErrors('code')
              }}
              errorMessage={errors.code?.message as string}
            />
          </div> */}
          <Input
            type="number"
            rounded="xl"
            icon="mdi-whatsapp"
            placeholder="Nomor whatsapp yang dapat dihubungi"
            errorMessage={errors.phone?.message as string}
            {...register('phone', {
              required: ERROR_MESSAGES.REQUIRED_PHONE,
              pattern: {
                value: rxNumber,
                message: ERROR_MESSAGES.VALID_NUMBER,
              },
              minLength: {
                value: 10,
                message: ERROR_MESSAGES.MINIMUM_10,
              },
              maxLength: {
                value: 15,
                message: ERROR_MESSAGES.MAXIMUM_15,
              },
            })}
          />
        </div>
        <Button type="submit" variant="primary" block rounded="xl" isLoading={isLoading}>
          {isLoading ? 'Mengambil antrean...' : 'Ambil Antrean'}
        </Button>
      </form>
      <div ref={ticketContainerRef} className="fixed left-[-9999px]"></div>
    </Modal>
  )
}

export default ModalPhone
